export default "__VITE_ASSET__B$8eC2XD__"